import React from "react"
import { StaticQuery, graphql } from "gatsby"
import PropTypes from "prop-types"
import { Global, css } from "@emotion/react"
import globalStyles from "src/styles/globalStyles"
import ScrollListener from "src/components/ScrollListener"
import IntersectionObserverPolyfill from "src/components/IntersectionObserverPolyfill"
import AppProvider from "src/state/AppState"
import "./reset.css"
import { Helmet } from "react-helmet"

const Layout = ({ children, location }) => (
  <>
    <Helmet>
      <script src="https://cmp.osano.com/RNuLKYLTpG/370158d8-dd69-4910-a14c-87c176f106bf/osano.js"></script>
    </Helmet>

    <StaticQuery
      query={graphql`
        query SiteTitleQuery {
          site {
            siteMetadata {
              title
            }
          }
        }
      `}
      render={data => (
        <>
          <Global
            styles={css`
              ${globalStyles}
            `}
          />
          <IntersectionObserverPolyfill>
            <AppProvider>
              <ScrollListener>{children}</ScrollListener>
            </AppProvider>
          </IntersectionObserverPolyfill>
        </>
      )}
    />
  </>
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
